import client from "../api/client";
export const getList = () => {
  return client('/api/managers').then(({ data }) => data.data);
};

export const getMembership = () => {
  return client('/api/managers/membership').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/managers/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/managers/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/managers', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/managers/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useManagerService () {
  return {
    getList,
    getMembership,
    addEditModel,
    getDetail,
    delModel,
  };
}
